<app-page [pageTitle]="'reports.saved_reports'"
          [contentFullHeight]="true"
          [loader]="loading$ | async">
  <div actions class="display-flex flex-align-center gap-1-rem">
    <app-help-button template="saved-reports"></app-help-button>
    <app-fullscreen-button></app-fullscreen-button>
  </div>
  <div content style="overflow: auto;">
    <ng-container *ngIf="initialized$ | async">
      <mat-drawer-container class="reportNavBar full-height">
        <mat-drawer #reportSideNav
                    mode="over"
                    position="end"
                    [autoFocus]="false">
          <ng-container *ngIf="navReport">
            <app-saved-report-view-drawer [report]="navReport"
                                          (onClose)="reportSideNav.close()"></app-saved-report-view-drawer>
          </ng-container>
        </mat-drawer>
        <mat-drawer-content class="position-unset">
          <app-search-filter *ngIf="searchBar.searchCtrl.value"
                             (click)="searchBar.clear()"></app-search-filter>
          <div style="padding: 1rem 2rem 2rem 2rem;"
               cdkDropListGroup>
            <app-folder-selector-dialog-breadcrumb [showHelpText]="false"
                                                   [path]="breadcrumbs$ | async"
                                                   [folder]="currentFolder$ | async"
                                                   [backIsEnabled]="(currentFolder$ | async).payload.id !== null"
                                                   (onFolderSelect)="selectFolder($event)"
                                                   (onFolderBack)="onFolderBack()">
              <div class="display-flex gap-1-rem flex-align-center">
                <app-search-container>
                  <app-search-bar #searchBar></app-search-bar>
                  <app-search-results [value]="searchBar.searchCtrl.value"
                                      (onFilter)="onSearchFilter(searchBar, $event)"
                                      (onOpen)="onSearchOpen(searchBar, $event)"
                                      *ngIf="searchBar.searchCtrl.value"></app-search-results>
                </app-search-container>
                <app-edit-folder-button [folder]="currentFolder$ | async"
                                        [disabled]="false"
                                        *ngIf="(currentFolder$ | async)?.payload?.id !== null"></app-edit-folder-button>
              </div>
            </app-folder-selector-dialog-breadcrumb>
            <app-section-dropdown>
              <div title class="section-title">{{ "folders.folders" | translate }}</div>
              <div content class="display-flex flex-wrap gap-1-rem section-folder-content">
                <app-parent-folder-card cdkDropList
                                        (cdkDropListDropped)="moveReportToParentFolder($event)"
                                        [folder]="(parentFolder$ | async)"
                                        [customToolTip]="'reports.drop_move_to_parent' | translate"
                                        *ngIf="(currentFolder$ | async)?.payload?.id && (reports$ | async).length"></app-parent-folder-card>
                <app-folder-card *ngFor="let folder of folders$ | async"
                                 [ngClass]="{ selected: folder === searchFilter }"
                                 [folder]="folder"
                                 (click)="selectFolder(folder)"
                                 cdkDropList
                                 appScrollto
                                 [selected]="folder === searchFilter"
                                 (cdkDropListDropped)="drop($event, folder)"></app-folder-card>
                <app-add-folder-card [customToolTip]="'reports.add_folder' | translate"
                                     [folder]="currentFolder$ | async"></app-add-folder-card>
              </div>
            </app-section-dropdown>
            <app-section-dropdown>
              <div title class="section-title">{{ "reports.reports" | translate }}</div>
              <div content cdkDropList
                   class="reports-container"
                   [cdkDropListData]="reports$ | async | tableSort:tableHeader.sort">
                <app-report-table-header #tableHeader></app-report-table-header>
                <app-report-table-row (onInfo)="openReportNav(report)"
                                      (onOpen)="onOpenClicked(report)"
                                      (onOpenInNewTab)="onOpenInNewTab(report)"
                                      (onPublic)="openReportNav(report)"
                                      (onDragActive)="disableDragDrop = !$event"
                                      [cdkDragDisabled]="(report.loading$ | async) || !(savedReportsInitialized$ | async) || disableDragDrop"
                                      [report]="report"
                                      [selected]="report === searchFilter"
                                      [ngClass]="{ selected: report === searchFilter }"
                                      [loading]="report.loading$ | async"
                                      [lockDrag]="!(savedReportsInitialized$ | async)"
                                      cdkDrag
                                      appScrollto
                                      *ngFor="let report of reports$ | async | tableSort:tableHeader.sort">
                  <ng-container *cdkDragPreview>
                    <app-report-table-row [report]="report"></app-report-table-row>
                  </ng-container>
                  <ng-container *cdkDragPlaceholder></ng-container>
                </app-report-table-row>
                <app-report-table-row-add-report [folder]="currentFolder$ | async"
                                                 [customToolTip]="'reports.add_report' | translate"></app-report-table-row-add-report>
              </div>
            </app-section-dropdown>
          </div>
        </mat-drawer-content>
      </mat-drawer-container>
    </ng-container>
  </div>
</app-page>
